/* ILARA London — drawer + newsletter behaviour.
   Ported from the approved design. Cart opening is delegated to
   Horizon's own <theme-drawer id="cart-drawer">, so cart state stays real. */
(function () {
  var scrim = document.getElementById('scrim');
  var open = null;

  function show(id) {
    var el = document.getElementById(id);
    if (!el || !scrim) return;
    close();
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');
    scrim.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('on'); });
    document.body.style.overflow = 'hidden';
    open = el;
    var f = el.querySelector('[data-close]');
    if (f) f.focus();
  }

  function close() {
    if (!open) return;
    open.classList.remove('on');
    open.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('on');
    document.body.style.overflow = '';
    open = null;
    setTimeout(function () {
      if (scrim && !document.querySelector('.drawer.on')) scrim.hidden = true;
    }, 320);
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); show(o.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]')) { close(); return; }
    if (e.target === scrim) { close(); }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* Header utilities delegate to Horizon's own components so search,
     cart state and checkout keep working. */
  document.addEventListener('click', function (e) {
    var cartBtn = e.target.closest('[data-ilara-cart]');
    if (cartBtn) {
      var drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.toggle === 'function') {
        e.preventDefault();
        close();
        drawer.toggle();
      }
      return;
    }
    var searchBtn = e.target.closest('[data-ilara-search]');
    if (searchBtn) {
      var modal = document.getElementById('search-modal');
      if (modal && typeof modal.showDialog === 'function') {
        e.preventDefault();
        close();
        modal.showDialog();
      }
    }
  });

  /* Country/currency selector — submitting Shopify's localization form
     reloads the page into the chosen market. The <noscript> button covers
     the no-JS case, so this listener is the only wiring needed. */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ilara-loc]');
    if (sel && sel.form) sel.form.submit();
  });

  /* Favourites. A list of product handles in localStorage — no account, so it
     works for everyone, and it is per-browser by design. Every read and write
     is guarded: Safari private mode throws on localStorage rather than
     returning null, which would otherwise take the whole script down. */
  var FAV_KEY = 'ilara:favourites';

  function favRead() {
    try {
      var v = JSON.parse(localStorage.getItem(FAV_KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }

  function favWrite(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {}
  }

  /* Paints every button and counter on the page from storage. Called on load,
     after a toggle, and after the favourites page injects fetched cards. */
  function favSync() {
    var list = favRead();
    var buttons = document.querySelectorAll('[data-ilara-fav]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var on = list.indexOf(b.getAttribute('data-ilara-fav')) !== -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = b.querySelector('[data-ilara-fav-label]');
      if (lbl) lbl.textContent = on ? 'Saved' : 'Save this piece';
    }
    var counts = document.querySelectorAll('[data-ilara-fav-count]');
    for (var j = 0; j < counts.length; j++) {
      counts[j].textContent = '(' + list.length + ')';
      counts[j].hidden = list.length === 0;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ilara-fav]');
    if (!btn) return;
    /* The card is one big link via .hit::after; the button outranks it on
       z-index, but stop the event dead in case it is ever nested inside. */
    e.preventDefault();
    e.stopPropagation();

    var handle = btn.getAttribute('data-ilara-fav');
    var list = favRead();
    var at = list.indexOf(handle);
    var adding = at === -1;
    if (adding) list.unshift(handle); else list.splice(at, 1);
    favWrite(list);
    favSync();

    if (adding) {
      btn.classList.remove('fav--pop');
      void btn.offsetWidth;
      btn.classList.add('fav--pop');
    }

    /* Un-saving while standing on the favourites page should remove the card. */
    var grid = document.querySelector('[data-ilara-fav-grid]');
    if (!adding && grid) {
      var card = btn.closest('.card');
      if (card && grid.contains(card)) {
        card.classList.add('is-going');
        setTimeout(function () { card.remove(); favPageState(); }, 250);
      }
    }
  });

  /* Shows the grid, the empty state or neither, from what is actually in it. */
  function favPageState() {
    var grid = document.querySelector('[data-ilara-fav-grid]');
    if (!grid) return;
    var wait = document.querySelector('[data-ilara-fav-wait]');
    var empty = document.querySelector('[data-ilara-fav-empty]');
    var note = document.querySelector('[data-ilara-fav-note]');
    var has = grid.querySelectorAll('.card').length > 0;
    if (wait) wait.hidden = true;
    grid.hidden = !has;
    if (empty) empty.hidden = has;
    if (note) note.hidden = !has;
  }

  /* Builds the favourites page. Each saved handle is fetched through
     ?view=card, so the markup is the same Liquid card used everywhere else and
     the price, badges and remaining sizes are current rather than whatever was
     true when the visitor saved it. A handle that 404s (piece deleted or
     unpublished) is quietly dropped from storage. */
  function favPageInit() {
    var grid = document.querySelector('[data-ilara-fav-grid]');
    if (!grid) return;

    var list = favRead();
    if (!list.length) { favPageState(); return; }

    Promise.all(list.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '?view=card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    })).then(function (parts) {
      var kept = [];
      var html = '';
      for (var i = 0; i < parts.length; i++) {
        if (parts[i]) { kept.push(list[i]); html += parts[i]; }
      }
      if (kept.length !== list.length) favWrite(kept);
      grid.innerHTML = html;
      favPageState();
      favSync();
    });
  }

  favSync();
  favPageInit();

  /* Saved in another tab — keep this one honest. */
  window.addEventListener('storage', function (e) {
    if (e.key === FAV_KEY) favSync();
  });

  /* Keep the header bag count in step with the real cart. Horizon emits
     shopify:cart:lines-update with a promise resolving to the updated cart;
     a /cart.js read backs it up so the count is right either way. */
  function syncCount(n) {
    if (typeof n !== 'number') return;
    document.querySelectorAll('[data-ilara-cart-count]').forEach(function (el) {
      el.textContent = '(' + n + ')';
    });
    document.querySelectorAll('[data-ilara-cart]').forEach(function (el) {
      el.setAttribute('aria-label', n === 1 ? 'Open bag, 1 item' : 'Open bag, ' + n + ' items');
    });
  }

  function refetchCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) syncCount(cart.item_count); })
      .catch(function () {});
  }

  document.addEventListener('shopify:cart:lines-update', function (e) {
    var p = e && e.promise;
    if (p && typeof p.then === 'function') {
      p.then(function (result) {
        var n = result && result.cart && result.cart.totalQuantity;
        if (typeof n === 'number') syncCount(n);
        else refetchCount();
      }).catch(refetchCount);
    } else {
      refetchCount();
    }
  });
})();

/* Card films play only while their card is on screen. The autoplay
   attribute starts them without JS; this pauses whatever scrolls out of
   view and restarts it on return, so a grid of films doesn't drain a
   phone battery. Collection grids append cards via infinite scroll, so
   new videos are picked up as they arrive. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting && !reduced.matches) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.2 });

  function watch(v) {
    if (v.dataset.ilaraFilm) return;
    v.dataset.ilaraFilm = '1';
    if (reduced.matches) {
      v.removeAttribute('autoplay');
      v.pause();
      return;
    }
    io.observe(v);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.card-fig video, .clients-tile video').forEach(watch);
  }

  scan(document);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* iOS Low Power Mode rejects autoplay outside a user gesture — but a
     scroll IS a gesture. On every touch, retry whichever films are on
     screen, so the first scroll starts them even on a saving battery. */
  document.addEventListener('touchend', function () {
    if (reduced.matches) return;
    document.querySelectorAll('.card-fig video, .hero-slide.is-on video, .clients-tile video').forEach(function (v) {
      if (!v.paused) return;
      var r = v.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    });
  }, { passive: true });
})();
